/* Development */

export const environment = {
  production: false,
  api: 'https://dms.mycar-india.com/api',
  // api: 'http://192.168.0.116:8000/api',
  base_path: 'https://stage-storage-mycar-mumbai.s3.ap-south-1.amazonaws.com/',
  dms: 'https://dms.mycar-india.com/',
  domain: 'http://localhost:4200',
  enableSW: false // Service worker disabled in dev
};

/* Production */

// export const environment = {
//   production: true,
//   api: 'https://dms.my-car.com/api',
//   base_path: 'https://s3.ap-south-1.amazonaws.com/storage-mycar-mumbai/',
//   dms: 'https://dms.my-car.com/',
//   domain: 'https://vam.my-car.com',
//   enableSW: true
// };
